import { render } from "./BlogPostPreview.vue?vue&type=template&id=ff2bd15c"
import script from "./BlogPostPreview.vue?vue&type=script&lang=js"
export * from "./BlogPostPreview.vue?vue&type=script&lang=js"

import "./BlogPostPreview.vue?vue&type=style&index=0&id=ff2bd15c&lang=css"

import exportComponent from "/builds/dalmadima/umzugbayernwebapp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__